import React from "react";

/**
 * GlassDefs — the SVG filters the CSS glass system references via
 * `backdrop-filter: url(#bb-glass-refraction)`. Mount ONCE near the app
 * root (see App.tsx). Renders a zero-footprint, hidden, aria-hidden <svg>.
 *
 * The refraction is a fractal-noise displacement map: it nudges the blurred
 * backdrop around so the surface reads as refractive glass instead of flat
 * frost. `-strong` is for hero moments; the default is tuned subtle enough
 * to keep data surfaces legible.
 */
const GlassDefs: React.FC = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="0"
    height="0"
    style={{
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden",
      pointerEvents: "none",
    }}
  >
    <defs>
      <filter
        id="bb-glass-refraction"
        x="-20%"
        y="-20%"
        width="140%"
        height="140%"
        colorInterpolationFilters="sRGB"
      >
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.009 0.013"
          numOctaves={2}
          seed={7}
          result="noise"
        />
        <feGaussianBlur in="noise" stdDeviation="2.2" result="softNoise" />
        <feDisplacementMap
          in="SourceGraphic"
          in2="softNoise"
          scale="16"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>

      <filter
        id="bb-glass-refraction-strong"
        x="-25%"
        y="-25%"
        width="150%"
        height="150%"
        colorInterpolationFilters="sRGB"
      >
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.012 0.016"
          numOctaves={2}
          seed={11}
          result="noise"
        />
        <feGaussianBlur in="noise" stdDeviation="2.6" result="softNoise" />
        <feDisplacementMap
          in="SourceGraphic"
          in2="softNoise"
          scale="34"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
    </defs>
  </svg>
);

export default GlassDefs;
